import { NextPage } from 'next'
import BankVirtualCollectionScreen from '../screens/BankVirtualCollection'

export const BankVirtualCollection: NextPage = () => {

  return (
    <>
      <BankVirtualCollectionScreen />
    </>
  )
}